<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Grocery List</h1>

        <div class="my-4"> </div>
        <!-- <aha-grocery-list title="Awesome List" :count="5" :preset-values="presetvalues"></aha-grocery-list> -->
        <aha-grocery-list title="Awesome List" :count="5" ></aha-grocery-list>

        <p class="my-4">
        To see preset list for testing, use the console to clear localstorage.
        <pre>localStorage.clear()</pre>
        </p>

        <div class="text-center">
  <!-- <b-spinner variant="primary" label="Text Centered"></b-spinner> -->
</div>

    </div>
</template>

<script>
import {itemsStorageFunc} from '@/utils/items-storage';
const STORAGE_KEY = '_aha-coveo-grocery-list';
const presetValues = [
    {"title":"Rancho Pecana Natural Pecan Halves", "completed":false},
    {"title":"WestSoy Organic Original Soymilk", "completed":false},
    {"title":"Kirkland Signature Boneless Skinless Chicken Breast 99% Fat Free", "completed":false},
    {"title":"Mother Earth Fresh Premium Idaho/Russet Potatoes", "completed":false},
    {"title":"Garcia de la Cruz Organic Extra Virgin Olive Oil", "completed":false},
    {"title":"Food Lion 96% Lean 4% Fat Ground Beefs", "completed":false},
    {"title":"Health Valley Organic Low Sodium Chicken and Rice Soup", "completed":false},
];
export default {
    created() {
        var items = JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || presetValues;
        itemsStorageFunc.save(STORAGE_KEY, items);
    }
}
</script>



// WEBPACK FOOTER //
// demo/pages/components/grocery-list.vue